import { useAtom, useSetAtom } from 'jotai';

import { AudioVideoTroubleshootActionItemWrapper as BaseAudioVideoTroubleshootActionItem } from '../components/help-modal/AudioVideoTroubleshootActionItemWrapper';
import { useInitAvailableDevices } from '../session/devices/useDevices';
import { HelpModal } from './HelpModal';
import { ProviderDrawerState, drawerStateAtom, providerIsHelpModalOpenAtom } from './state';

export function HelpModalWrapper() {
  useInitAvailableDevices();
  const [isHelpModalOpen, setIsHelpModalOpen] = useAtom(providerIsHelpModalOpenAtom);
  const setDrawerState = useSetAtom(drawerStateAtom);
  const openSettings = () => {
    setIsHelpModalOpen(false);
    setDrawerState(ProviderDrawerState.SETTINGS);
  };

  return (
    <HelpModal
      isOpen={isHelpModalOpen}
      onClose={() => setIsHelpModalOpen(false)}
      audioVideoTroubleshootActionItem={<BaseAudioVideoTroubleshootActionItem onOpenSettings={openSettings} />}
    />
  );
}
